export default __webpack_public_path__ + "static/media/aboutMePic.365bf3ae.jpeg";